import { render } from "./App.vue?vue&type=template&id=be7ba0b2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=be7ba0b2&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=be7ba0b2&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7ba0b2"]])

export default __exports__